import { PortalSettingsStoreType, VehicleWeightLimitFilterMode, VehicleParametersExceedeFilterMode } from './types';

export function deserializePortalSettings(json: string): PortalSettingsStoreType {
  const raw = JSON.parse(json);

  return {
    weightLimitFilterMode:
      typeof raw.weightLimitFilterMode === 'string'
        ? VehicleWeightLimitFilterMode[raw.weightLimitFilterMode as keyof typeof VehicleWeightLimitFilterMode]
        : raw.weightLimitFilterMode,
    parametersExceededFilterMode:
      typeof raw.parametersExceededFilterMode === 'string'
        ? VehicleParametersExceedeFilterMode[raw.parametersExceededFilterMode as keyof typeof VehicleParametersExceedeFilterMode]
        : raw.parametersExceededFilterMode,
  };
}